export default __webpack_public_path__ + "static/AlertNotification-7be14329018cea57b9c3e10574c95aac.png";